// extracted by mini-css-extract-plugin
module.exports = {"item":"contents-module__item___1hc6c"};